import React from "react";
import "./about.css";

const About = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      console.log("Contact section not found - in a real app, this would navigate to contact page");
      alert("Contact section not available. This would navigate to the contact page in the full application.");
    }
  };

  return (
    <section className="about-section" id="about">
      <div className="about-container">
        
        {/* Hero Section */}
        <div className="about-hero">
          <h1 className="about-main-title">
            About <span className="gradient-text">Charamy.org</span>
          </h1>
          <p className="about-tagline">Growth-focused. Data-backed. Crypto-native.</p>
        </div>

        {/* Stats Section */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">2+</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">400+</div>
            <div className="stat-label">Crypto KOLs</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">50+</div>
            <div className="stat-label">Projects</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">150%</div>
            <div className="stat-label">Avg ROI</div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          <div className="feature-card">
            <h3>Not Just Another Agency</h3>
            <p>We're a growth engine for ambitious crypto projects seeking real market impact.</p>
          </div>
          
          <div className="feature-card">
            <h3>Data-Backed Strategies</h3>
            <p>Every campaign is backed by analytics and proven frameworks that drive actual growth.</p>
          </div>
          
          <div className="feature-card">
            <h3>Direct KOL Access</h3>
            <p>No middlemen. Direct relationships with 400+ verified crypto influencers.</p>
          </div>
        </div>

        {/* Mission Section */}
        <div className="mission-section">
          <div className="mission-card">
            <h2>Our Mission</h2>
            <p className="mission-text">
              "Turning quiet launches into <span className="highlight">market-wide conversations</span> 
              through deep crypto expertise and strategic storytelling."
            </p>
            
            <div className="mission-content">
              <p>
                For the past <strong>2+ years</strong>, we've helped projects move from 
                <span className="highlight"> zero visibility to mainstream recognition</span>, 
                transforming quiet launches into industry-wide discussions.
              </p>
              
              <p>
                Our team combines <strong>deep crypto expertise</strong>, strategic storytelling, 
                and influencer networks that drive <span className="highlight">real investor attention</span> not just vanity numbers.
              </p>
            </div>

            {/* Services List */}
            <div className="services-list">
              <h4>What We Specialize In:</h4>
              <div className="services-grid">
                <div className="service-item">
                  <span>Prelaunch Campaigns</span>
                </div>
                <div className="service-item">
                  <span>Token Listings</span>
                </div>
                <div className="service-item">
                  <span>Community Activation</span>
                </div>
                <div className="service-item">
                  <span>KOL Marketing</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <div className="cta-card">
            <h2>Ready to Dominate Crypto Space?</h2>
            <p>Having Charamy by your side isn't optional it's your unfair advantage.</p>
            <button onClick={scrollToContact} className="btn-primary">
              Start Your Journey
            </button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;